export enum SectorAssignationsEntityType {
  USERS = "users",
  USER_GROUPS = "userGroups",
  DTWINS = "dtwins",
}
